/**
 * Created by AlexanderC on 5/27/15.
 */

'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Policy = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _Extractable2 = require('./Extractable');

var _Collection = require('./Collection');

var _Statement = require('./Statement');

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * IAM policy
 */
let Policy = exports.Policy = function (_Extractable) {
  _inherits(Policy, _Extractable);

  function Policy() {
    _classCallCheck(this, Policy);

    var _this = _possibleConstructorReturn(this, (Policy.__proto__ || Object.getPrototypeOf(Policy)).call(this));

    _this._version = Policy.DEFAULT_VERSION;
    _this._statement = new _Collection.Collection(_Statement.Statement);
    return _this;
  }

  /**
   * @returns {String}
   */


  _createClass(Policy, [{
    key: 'extract',


    /**
     * @return {Object}
     */
    value: function extract() {
      return {
        Version: this._version,
        Statement: this._statement.extract()
      };
    }

    /**
     * @return {String}
     */

  }, {
    key: 'toString',
    value: function toString() {
      return JSON.stringify(this.extract());
    }
  }, {
    key: 'version',


    /**
     * @param {String} version
     */
    set: function set(version) {
      this._version = version;
    }

    /**
     * @returns {String}
     */
    ,
    get: function get() {
      return this._version;
    }

    /**
     * @returns {Collection}
     */

  }, {
    key: 'statement',
    get: function get() {
      return this._statement;
    }
  }], [{
    key: 'ANY',
    get: function get() {
      return '*';
    }

    /**
     * @returns {String}
     */

  }, {
    key: 'DEFAULT_VERSION',
    get: function get() {
      return '2012-10-17';
    }
  }]);

  return Policy;
}(_Extractable2.Extractable);


//////////////////
// WEBPACK FOOTER
// ../~/deep-core/lib.compiled/AWS/IAM/Policy.js
// module id = 66
// module chunks = 0